import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../../components/button";
import { IMAGES } from "../../../../../assets/images";

const Mobile = ({ onPageUpdate, onFormSubmit, isLoader }) => {
  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      phoneNumber: Yup.string()
        .matches(/^\d+$/, "Phone Number must be numeric")
        .required("Phone Number is required"),
    }),
    onSubmit: (values) => {
      console.log("Form data:", values);
      onFormSubmit(values);
    },
  });

  return (
    <div>
      <div className="flex justify-center mb-4">
        <img src={IMAGES.logo} alt="" className="w-[180px] sm:w-[225px]" />
      </div>
      <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-center">
        Login to your account
      </h2>
      <form
        onSubmit={formik.handleSubmit}
        className="space-y-4 w-full sm:w-[85%] md:w-[75%] lg:w-[65%] mx-auto"
      >
        {/* Email Address */}
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Mobile Number *
          </label>
          <input
            type="number"
            id="phoneNumber"
            name="phoneNumber"
            className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.phoneNumber && formik.errors.phoneNumber ? "border-red-500" : "border-gray-300"}`}
            value={formik.values.phoneNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength="10"
          />
          {formik.touched.phoneNumber && formik.errors.phoneNumber && (
            <p className="text-red-500 text-sm mt-1">
              {formik.errors.phoneNumber}
            </p>
          )}
          <p
            className="mt-3 mb-1 text-sm text-right text-blue-500 hover:underline cursor-pointer"
            onClick={() => onPageUpdate("signIn")}
          >
            Login with Password
          </p>
        </div>

        <CustomButton title={"Send OTP"} type="submit" loader={isLoader} />
      </form>
      <p className="mt-4 text-center text-sm text-gray-600">
        Don't have an account?{" "}
        <span
          className="text-blue-500 hover:underline cursor-pointer"
          onClick={() => onPageUpdate("signUp")}
        >
          Sign Up
        </span>
      </p>
    </div>
  );
};

export default Mobile;
